export class ContentModel {
    id:number;
    menuId: number;
    headerText: string;
    headerImage: string;
    bottomText: string;
   
}
